import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import BugReportIcon from '@mui/icons-material/BugReport';
import CVEScanner from '../components/security/CVEScanner';
import PenTestScanner from '../components/security/PenTestScanner';

function SecurityDashboard() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <SecurityIcon fontSize="large" />
        Security Scanner
      </Typography>

      <Paper elevation={3} style={{ marginTop: '20px' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            icon={<BugReportIcon />}
            label="CVE Scanner"
            iconPosition="start"
          />
          <Tab
            icon={<SecurityIcon />}
            label="Penetration Testing"
            iconPosition="start"
          />
        </Tabs>

        <Box p={3}>
          {activeTab === 0 && <CVEScanner />}
          {activeTab === 1 && <PenTestScanner />}
        </Box>
      </Paper>
    </div>
  );
}

export default SecurityDashboard;
